import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

import { LoginComponent } from './login.component';
import { LogoutComponent } from './logout.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([
      { path: 'login', component: LoginComponent },
      { path: 'logout', component: LogoutComponent }
    ])
  ],
  declarations: [
    LoginComponent,
    LogoutComponent
  ]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts